import React from 'react';
import clsx from 'clsx';
import Marquee from 'react-fast-marquee';

import styles from '../styles.module.scss';
import antiSpamStyles from './AntiSpam.module.scss';
import {ArrowLong} from '../../../assets';
import {
  Message1,
  Message2,
  Message3,
  Message4,
  Message5,
  Message6,
} from '../../../assets/icons/antiSpam';

export const AntiSpamCard = () => {
  return (
    <div className={antiSpamStyles.card}>
      <div className={antiSpamStyles.content}>
        <div className={styles.top}>
          <div className={clsx(styles.label, styles.moderation)}>
            <div className={clsx(styles.labelInner, styles.moderation)}>moderation</div>
          </div>
          <div className={styles.buttonForward}>
            <ArrowLong />
          </div>
        </div>

        <h4 className={styles.title}>Anti-Spam</h4>
        <p className={styles.subTitle}>
          Themis recognises potentially harmful messages such as repeated messages, Zalgo text, and
          external links.
        </p>
      </div>

      <div className={antiSpamStyles.messages}>
        <Marquee speed={50} gradient={false} className={antiSpamStyles.marquee}>
          <Message1 />
          <Message2 />
          <Message3 />
          <Message4 />
          <Message5 />
          <Message6 />
        </Marquee>
        <Marquee speed={50} gradient={false} direction="right" className={antiSpamStyles.marquee}>
          <Message1 />
          <Message2 />
          <Message3 />
          <Message4 />
          <Message5 />
          <Message6 />
        </Marquee>
        <Marquee speed={40} gradient={false} className={antiSpamStyles.marquee}>
          <Message1 />
          <Message2 />
          <Message3 />
          <Message4 />
          <Message5 />
          <Message6 />
        </Marquee>
      </div>
    </div>
  );
};
